import { render, staticRenderFns } from "./ManageTrustModal.vue?vue&type=template&id=74bc9f18&"
import script from "./ManageTrustModal.vue?vue&type=script&lang=ts&"
export * from "./ManageTrustModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports